<template>
  <div id="select-voucher-dialog">
    <ipub-model :title="`Select Voucher`"
                width="1066px"
                class="copyright-documents"
                :visable="isVisable"
                @cancel="cancel"
                :showFooter="false">
      <div class="flex discount-list"
           v-if="discountList && discountList.length>0">
        <div v-for="item in discountList"
             :key="item.id"
             :class="['ipub-p2', 'discount-item', 'relative', 'mar-b-10',['SELECTED','USED','EXPIRED'].includes(item.status)? 'disable':'']">
          <div class="discount-item-discount mar-b-10 ipub-h1">{{item.discount}} USD
            <div class="discount-item-discount-status ipub-p1 link-color"
                 v-if="item.status !=='UNUSED' || (item.status ==='UNUSED' && item.__selected)">
              <div style="border: 2px solid ;width: 90px;">
                {{item.__selected ? 'Selected': DISCOUNT_STATUS[item.status]}}
              </div>
            </div>
          </div>
          <div class="discount-item-other">
            <div class="fw-bd mar-b-6">General Discount</div>
            <div class="mar-b-20">Code: {{item.code}} <ipub-icon @click="copyCode(item.code)"
                         class="ipub-c-p mar-l-5"
                         type="iconduplicate"></ipub-icon>
            </div>
            <div>Exp: {{$moment(item.expiredTime).format('DD / MM / YYYY')}}</div>
            <div>* Apply to all journals</div>
          </div>
          <div class=""
               style="position:absolute;bottom:12px;left:8px">
            <!--  {{item.__selected}} -->
            <ipub-button type="primary"
                         @click="addDiscount(item)"
                         v-if="!['SELECTED','USED','EXPIRED'].includes(item.status)"
                         style="width:140px;border-radius:0"
                         size="small">{{item.__selected?'Unselect It':'Use It'}}</ipub-button>

          </div>
        </div>
      </div>
      <div style="text-align:center"
           v-else>
        <ipub-empty text=""
                    icon="iconVoucher"
                    title="" />
        <div class="ipub-h1">There is no voucher in the current account. </div>
        <div class="ipub-p1"><a target="_blank"
             class="link-color"
             href="https://www.imrpress.com/resources/for_reviewers">How to get a discount voucher?</a></div>
      </div>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { discountDetail } from '@/api/discount'
import { DISCOUNT_STATUS } from '@/utils/dict'
import help from '@/utils/help'

export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Array,
      default () {
        return []
      },
    },
  },
  data () {
    return {
      discountList: [],
      DISCOUNT_STATUS,
      selectDiscountList: []
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      journalId: 'getJournalId',
      title: 'getTitle',
      domain: 'getDomain',
      country: 'getCountry'
    })
  },
  watch: {
    isVisable: {
      handler (val) {
        if (val) {
          this.getQuery()
          this.selectDiscountList = this.inputData

        }
      },
      immediate: true
    }
  },
  methods: {
    async getQuery () {
      this.discountList = await discountDetail.detailPerson()
      // this.discountList = this.discountList.concat(this.discountList)
      const selectId = this.selectDiscountList.map(val => val.id)
      this.discountList.map(item => {
        item.__selected = false
        if (selectId.includes(item.id)) {
          item.__selected = true
          // RCM01220831c9dcdf7a73084ff3
        }
      })
    },

    addDiscount (val) {
      let index = -1
      for (let i = 0; i < this.selectDiscountList.length; i++) {
        const item = this.selectDiscountList[i]
        if (item.code === val.code) {
          index = i
        }
      }
      if (index >= 0) {
        val.__selected = false
        this.selectDiscountList.splice(index, 1)
      } else {
        val.__selected = true
        this.selectDiscountList.push(val)
      }
      this.discountList = JSON.parse(JSON.stringify(this.discountList))
      // console.log(val, 'cc', this.selectDiscountList)
      this.$emit('confirm', this.selectDiscountList)
    },
    copyCode (val) {
      help.copyToBlock(val)
      this.$message.success({
        title: 'Success',
        content: 'The code has been copied to the clipboard!'
      })
    },
    cancel () {
      this.$emit('cancel')
    },
  }
}
</script>

<style lang="scss" scoped>
#select-voucher-dialog {
  .discount-list {
    flex-wrap: wrap;
  }
  .discount-item {
    width: 314px;
    height: 327px;
    box-shadow: 3px 3px 6px 1px rgba(202, 212, 217, 0.16);
    border: 1px solid $disable_color;
    margin-right: 10px;
    &-discount {
      text-align: center;
      height: 140px;
      line-height: 140px;
      background: rgba($link_color, 0.5);
      position: relative;
      font-size: 56px;
      color: $content_color;
      &-status {
        position: absolute;
        top: 72px;
        border: 1px solid $link_color;
        -webkit-transform: rotateX(45deg);
        transform: rotate(-15deg);
        left: 156px;
        padding: 2px;
      }
    }
    &-other {
      padding: 0 8px;
      .iconfont {
        color: $link_color;
      }
    }
  }
  .disable {
    .discount-item-discount {
      text-align: center;
      color: $default_color;
      background: rgba($default_color, 0.5);
    }
    .discount-item-discount-status {
      border: 2px solid $line_color;
      color: $line_color;
    }
    .discount-item-other {
      // color: $default_color;
      padding: 0 8px;
      .iconfont {
        color: $default_color;
      }
    }
  }
}
</style>
